import * as React from 'react'
const SvgChevronUpOutlined = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 25"
    width="1em"
    height="1em"
    {...props}
  >
    <path
      fill="#60636B"
      fillRule="evenodd"
      d="M18.956 16.986a.75.75 0 0 0 1.06-1.062l-7.588-7.572a.75.75 0 0 0-1.065.005l-7.576 7.568a.75.75 0 1 0 1.06 1.06l6.98-6.972a.1.1 0 0 1 .142 0z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgChevronUpOutlined
